export default {
  'Default: 250 Files per Day': {
    handleChange: (onChange) => onChange({}, 'num_files', 250),
  },
  'If there is a restriction with the above, list accepted # of files per day ': {
    handleChange: (onChange, value) => onChange({}, 'num_files', parseInt(value, 10)),
  },
}
